import axios from '../axiosSetup';

const API = "/product";

export const productService = {
  /**
   * Get all products (supports pagination, search, filters)
   */
  getAll: async (params = {}) => {
  try {
    const response = await axios.get(API, {
      params,
      paramsSerializer: {
        serialize: (params) => {
          const query = [];

          Object.keys(params).forEach((key) => {
            const value = params[key];

            if (Array.isArray(value)) {
              // produce ?entity=APS&entity=SBS
              value.forEach((v) => {
                query.push(`${key}=${encodeURIComponent(v)}`);
              });
            } else {
              query.push(`${key}=${encodeURIComponent(value)}`);
            }
          });

          return query.join("&");
        }
      }
    });

    return response.data;
  } catch (error) {
    console.error(" Error fetching products:", error);
    throw error.response?.data || error;
  }
},

  // getAll: async (params = {}) => {
  //   try {
  //     // ✅ FIXED → wrap params correctly so pagination updates table
  //     const response = await axios.get(API, { params });
  //     return response.data;
  //   } catch (error) {
  //     console.error('❌ Error fetching products:', error);
  //     throw error.response?.data || error;
  //   }
  // },

  /**
   * Get a single product by ID
   */
  getById: async (id) => {
    try {
      const response = await axios.get(`${API}/${id}`);
      return response.data;
    } catch (error) {
      console.error(`❌ Error fetching product ${id}:`, error);
      throw error.response?.data || error;
    }
  },

  /**
   * Create a new product
   */
  create: async (productData) => {
    try {
      const response = await axios.post(API, productData);
      return response.data;
    } catch (error) {
      console.error('❌ Error creating product:', error);
      throw error.response?.data || error;
    }
  },

  /**
   * Update product details by ID
   */
  update: async (id, productData) => {
    try {
      const response = await axios.put(`${API}/${id}`, productData);
      return response.data;
    } catch (error) {
      console.error(`❌ Error updating product ${id}:`, error);
      throw error.response?.data || error;
    }
  },

  /**
   * Upload a product image (multipart/form-data)
   */
  uploadImage: async (id, formData) => {
    try {
      const response = await axios.put(`${API}/${id}/upload-image`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      return response.data;
    } catch (error) {
      console.error(`❌ Error uploading image for product ${id}:`, error);
      throw error.response?.data || error;
    }
  },

  /**
   * Get product image as blob
   */
  getImage: async (id) => {
    try {
      const response = await axios.get(`${API}/${id}/image`, { responseType: 'blob' });
      return response.data;
    } catch (error) {
      console.error(`❌ Error fetching image for product ${id}:`, error);
      throw error.response?.data || error;
    }
  },

  /**
   * Toggle active/inactive status
   */
  toggleActive: async (id, isActive) => {
    try {
      const response = await axios.patch(`${API}/${id}/active`, { active: isActive });
      return response.data;
    } catch (error) {
      console.error(`❌ Error updating active status for product ${id}:`, error);
      throw error.response?.data || error;
    }
  },

  /**
   * Get product version history
   */
  getVersions: async (id) => {
    try {
      const response = await axios.get(`${API}/${id}/versions`);
      return response.data;
    } catch (error) {
      console.error(`❌ Error fetching versions for product ${id}:`, error);
      throw error.response?.data || error;
    }
  }
};
